import { useEffect, useState } from "react";
import {
  getStoredSortParams,
  setStoredSortParams,
} from "@helpers/localStorage";

export interface SortProperties {
  field: string;
  direction: TableSortDirection;
}

export const useTableSort = (
  defaultSort?: SortProperties,
  saveKey?: string
) => {
  const [sort, setSort] = useState<SortProperties | undefined>(() => {
    if (saveKey) {
      const stored = getStoredSortParams(saveKey);
      if (stored?.sortField && stored?.sortDirection) {
        return { field: stored.sortField, direction: stored.sortDirection };
      }
    }
    return defaultSort;
  });

  useEffect(() => {
    if (!saveKey || !sort?.field || !sort?.direction) return;
    setStoredSortParams(sort.field, sort.direction, saveKey);
  }, [saveKey, sort?.field, sort?.direction]);

  const handleSetSort = (field: string, direction?: TableSortDirection) => {
    setSort((current) => {
      if (field && direction) return { field, direction };

      if (current?.field !== field) {
        return { field, direction: "ASC" };
      }

      if (current?.direction === "DESC") {
        return { field, direction: "ASC" };
      }

      return { field, direction: "DESC" };
    });
  };

  return {
    sort: handleSetSort,
    sortField: sort?.field,
    sortDirection: sort?.direction,
  };
};
